/*
 * /document-signer — вкладка «Подписать».  DS.sign
 *
 * Подпись своим ключом в СТАНДАРТНОМ формате: CMS (.sig), подписанные атрибуты
 * CAdES-BES (время, хеш документа, привязка сертификата). Такую подпись
 * проверяет не только эта страница, но и openssl, КриптоАРМ-подобные
 * программы и любой разборщик PKCS#7 — человек не привязан к нашему сайту.
 *
 * Личность — самоподписанный сертификат на ключ: имя, почта и организация
 * ПОДПИСАНЫ (раньше печать подписывала только хеш файла, а имя и дату можно
 * было переписать в JSON, и проверка их всё равно показывала).
 *
 * Это не КЭП, и страница говорит об этом прямо: квалифицированная подпись
 * требует сертификата аккредитованного УЦ и сертифицированных средств.
 */
(function (root) {
    'use strict';
    var DS = root.DS, P = root.PKI;
    var S = DS.sign = {};
    var t = function (k, p) { return DS.t(k, p); };

    var st = {
        rec: null,            // запись из хранилища
        privateKey: null,     // CryptoKey, если ключ доступен
        kind: 'EC',
        files: [],            // документы
        src: 'file',          // 'file' | 'text'
        attached: false,
        timestamp: false,
        results: [],          // [{ name, docFile, sigBytes, sigName, timestamped }]
        busy: false,
        remember: true
    };
    var els = {};

    /* ═══ ключ и личность ════════════════════════════════════════════ */

    function persist() {
        if (!st.remember) return Promise.resolve();
        var rec = st.rec;
        if (!rec) return DS.store.clear();
        return DS.store.save(rec).catch(function () { /* хранилище недоступно — работаем в памяти */ });
    }

    function newRecord(keyPair, identity) {
        return DS.buildIdentityCert(keyPair, identity).then(function (c) {
            return DS.fingerprint(c.spki).then(function (fp) {
                return {
                    v: 3, alg: 'ECDSA-P256', created: Date.now(), imported: false, backedUp: false,
                    privateKey: keyPair.privateKey, publicKey: keyPair.publicKey, enc: null,
                    identity: identity, certDer: c.der, spki: c.spki, fingerprint: fp
                };
            });
        });
    }

    function generate(identity) {
        return crypto.subtle.generateKey({ name: 'ECDSA', namedCurve: 'P-256' }, true, ['sign', 'verify'])
            .then(function (kp) { return newRecord(kp, identity); })
            .then(function (rec) {
                st.rec = rec; st.privateKey = rec.privateKey; st.kind = 'EC';
                DS.ae('key_generate');
                return persist().then(function () { return rec; });
            });
    }

    /* Имя поменялось — выпускаем сертификат заново на ТОТ ЖЕ ключ: отпечаток
       не меняется, меняется только подписанное имя. */
    function ensureCert(identity) {
        var rec = st.rec;
        if (!rec || rec.imported) return Promise.resolve(rec);
        var same = rec.identity && rec.identity.name === identity.name && (rec.identity.email || '') === (identity.email || '') && (rec.identity.org || '') === (identity.org || '');
        if (same && rec.certDer) return Promise.resolve(rec);
        var pub = rec.publicKey ? Promise.resolve(rec.publicKey) :
            crypto.subtle.importKey('spki', DS.buf(rec.spki), { name: 'ECDSA', namedCurve: 'P-256' }, true, ['verify']);
        return pub.then(function (pk) {
            return DS.buildIdentityCert({ privateKey: st.privateKey, publicKey: pk }, identity);
        }).then(function (c) {
            rec.identity = identity; rec.certDer = c.der;
            return persist().then(function () { return rec; });
        });
    }

    function identityFromForm() {
        return {
            name: (els.name.value || '').trim().slice(0, 120),
            email: (els.email.value || '').trim().slice(0, 120),
            org: (els.org.value || '').trim().slice(0, 160)
        };
    }

    function renderKey() {
        var rec = st.rec, locked = rec && !st.privateKey && rec.enc;
        DS.show(els.keyNone, !rec);
        DS.show(els.keyHave, !!rec);
        DS.show(els.keyLocked, !!locked);
        els.root.classList.toggle('ds-key-ready', !!(rec && st.privateKey));
        if (rec) {
            var name = (rec.identity && rec.identity.name) || t('signer_default_name');
            DS.setData(els.keyName, name);
            els.keyAvatar.textContent = initials(name);
            els.keyFp.textContent = rec.fingerprint || '';
            els.keySub.textContent = rec.imported ? t('key_imported_badge') : (rec.enc ? t('key_protected_badge') : t('key_device_badge'));
            DS.show(els.backupNudge, !rec.backedUp && !rec.imported);
            DS.show(els.editIdentity, !rec.imported);
            DS.show(els.protectBtn, !rec.enc && !!st.privateKey);
            DS.show(els.unprotectBtn, !!rec.enc && !!st.privateKey);
        }
        refreshSignBtn();
    }
    function initials(name) {
        var w = String(name || '').split(/\s+/).filter(Boolean);
        return w.length ? (w[0][0] + (w[1] ? w[1][0] : '')).toUpperCase() : '?';
    }

    function refreshSignBtn() {
        var hasDoc = st.src === 'text' ? !!(els.text.value || '').trim() : st.files.length > 0;
        var locked = st.rec && !st.privateKey;
        els.go.disabled = !hasDoc || st.busy || !!locked;
        var n = st.src === 'text' ? 1 : st.files.length;
        els.goLabel.textContent = n > 1 ? DS.plural(n, 'sign_btn_n') : t('sign_btn');
        els.goHint.textContent = locked ? t('need_unlock') : (!hasDoc ? t('sign_need_doc') : (st.rec ? '' : t('sign_new_key_hint')));
    }

    /* ═══ документы ══════════════════════════════════════════════════ */

    function renderFiles() {
        els.files.innerHTML = '';
        st.files.forEach(function (f, i) {
            var row = DS.el('div', 'ds-file ds-r-document');
            row.appendChild(DS.icon('doc'));
            var tx = DS.el('div', 'ds-file-txt');
            var nm = DS.dataEl('span', 'ds-file-name', f.name); nm.title = f.name;
            tx.appendChild(nm);
            tx.appendChild(DS.el('span', 'ds-file-meta', DS.fmtSize(f.size)));
            row.appendChild(tx);
            var x = DS.el('button', 'ds-file-x', '×');
            x.type = 'button'; x.setAttribute('aria-label', t('remove')); x.title = t('remove');
            x.addEventListener('click', function () { st.files.splice(i, 1); renderFiles(); clearResults(); });
            row.appendChild(x);
            els.files.appendChild(row);
        });
        DS.show(els.filesWrap, st.files.length > 0);
        els.root.classList.toggle('ds-has-files', st.files.length > 0);
        refreshSignBtn();
        renderPreview();
    }
    function addFiles(files) {
        var seen = {};
        st.files.forEach(function (f) { seen[f.name + '|' + f.size + '|' + f.lastModified] = 1; });
        Array.prototype.forEach.call(files, function (f) {
            var k = f.name + '|' + f.size + '|' + f.lastModified;
            if (!seen[k] && f.size > 0) { st.files.push(f); seen[k] = 1; }
        });
        renderFiles(); clearResults();
        DS.ae('sign_files', { n: st.files.length });
        DS.stage('input', { tab: 'sign' });
    }
    S.addFiles = addFiles;

    /* Что получит получатель — до нажатия, чтобы «подпись в отдельном файле»
       не стала сюрпризом (самая частая путаница с .sig). */
    function renderPreview() {
        var host = els.preview;
        host.innerHTML = '';
        if (st.results.length) return;
        var names = st.src === 'text' ? [t('text_file_name')] : st.files.map(function (f) { return f.name; });
        DS.show(els.previewWrap, names.length > 0);
        DS.show(els.idle, names.length === 0);
        if (!names.length) return;
        var shown = names.slice(0, 3);
        shown.forEach(function (n) {
            var pair = DS.el('div', 'ds-pair');
            var doc = DS.el('span', 'ds-pair-doc');
            doc.appendChild(DS.icon('doc')); doc.appendChild(DS.dataEl('span', null, n));
            pair.appendChild(doc);
            pair.appendChild(DS.el('span', 'ds-pair-plus', st.attached ? '→' : '+'));
            var sig = DS.el('span', 'ds-pair-sig');
            sig.appendChild(DS.icon('seal')); sig.appendChild(DS.dataEl('span', null, n + '.sig'));
            pair.appendChild(sig);
            host.appendChild(pair);
        });
        if (names.length > shown.length) host.appendChild(DS.el('p', 'tc-note', t('preview_more', { n: names.length - shown.length })));
        els.previewNote.textContent = t(st.attached ? 'preview_attached' : 'preview_detached');
    }

    /* ═══ подпись ════════════════════════════════════════════════════ */

    // Штамп доверенного времени — через наш сервер: у серверов меток времени
    // нет CORS, браузер сам к ним не достучится. Уходит только хеш подписи.
    function requestTimestamp(signature) {
        var url = window.__DS_TS_URL;
        if (!url) return Promise.resolve(null);
        return crypto.subtle.digest('SHA-256', DS.buf(signature)).then(function (h) {
            var fd = new FormData();
            fd.append('hash', DS.hex(new Uint8Array(h)));
            var tok = document.querySelector('meta[name="csrf-token"]');
            return fetch(url, {
                method: 'POST', body: fd, credentials: 'same-origin', redirect: 'error',
                headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'X-CSRF-TOKEN': tok ? tok.content : '' }
            });
        }).then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (j) {
                if (!r.ok || !j.ok) {
                    var e = new Error(j.error || ('ts_' + r.status)); e.status = r.status; e.body = j; throw e;
                }
                // Ответ TSA целиком (TimeStampResp) → из него токен (ContentInfo).
                var resp = P.Asn1.parse(DS.unb64(j.token));
                var token = resp.children && resp.children[1];
                if (!token) throw new Error('ts_no_token');
                return token.full;
            });
        });
    }

    function sign() {
        if (st.busy) return;
        var identity = st.rec && st.rec.imported ? st.rec.identity : identityFromForm();
        if (!identity.name && !(st.rec && st.rec.imported)) {
            els.name.focus();
            DS.toast(t('err_need_name'), 'warning');
            return;
        }
        st.busy = true; refreshSignBtn();
        els.root.classList.add('ds-busy');
        var tsFailed = 0, tsDone = 0, tsLimit = null;
        var getKey = st.rec ? (st.privateKey ? Promise.resolve(st.rec) : Promise.reject(new Error('locked'))) : generate(identity);
        getKey.then(function () { return ensureCert(identity); }).then(function (rec) {
            var jobs = st.src === 'text'
                ? [{ name: t('text_file_name'), bytes: new TextEncoder().encode(els.text.value), text: true }]
                : st.files.map(function (f) { return { name: f.name, file: f }; });
            var out = [], i = 0;
            function next() {
                if (i >= jobs.length) return Promise.resolve(out);
                var j = jobs[i++];
                setProgress(t('signing_n', { i: i, n: jobs.length, name: j.name }));
                var digestP = j.bytes ? crypto.subtle.digest('SHA-256', DS.buf(j.bytes)).then(function (d) { return new Uint8Array(d); })
                    : DS.hashFile(j.file, '2.16.840.1.101.3.4.2.1', function (p) { setProgress(t('signing_n', { i: i, n: jobs.length, name: j.name }) + ' · ' + Math.round(p * 100) + '%'); });
                var contentP = st.attached ? (j.bytes ? Promise.resolve(j.bytes) : DS.readBytes(j.file)) : Promise.resolve(null);
                return Promise.all([digestP, contentP]).then(function (r) {
                    return P.Cms.build({
                        certDer: rec.certDer, privateKey: st.privateKey, contentDigest: r[0], content: r[1],
                        extraCerts: rec.extraCerts || [],
                        timestamp: st.timestamp && tsLimit === null ? function (sig) {
                            return requestTimestamp(sig).then(function (tok) { tsDone++; return tok; }, function (e) {
                                tsFailed++;
                                if (e && (e.status === 429 || e.status === 402 || (e.status === 403 && e.body && e.body.error_kind))) tsLimit = e.body || {};
                                return null;
                            });
                        } : null
                    });
                }).then(function (res) {
                    out.push({ name: j.name, file: j.file || null, bytes: j.bytes || null, sig: res.der, sigName: j.name + '.sig', timestamped: res.timestamped, text: !!j.text });
                    return next();
                });
            }
            return next();
        }).then(function (out) {
            st.results = out;
            renderResults({ tsDone: tsDone, tsFailed: tsFailed, tsLimit: tsLimit });
            autoDeliver();
            DS.stage('signed', { n: out.length });
            DS.ae('sign', { n: out.length, src: st.src, attached: st.attached ? 1 : 0, ts: st.timestamp ? 1 : 0, ts_ok: tsDone, ts_fail: tsFailed, imported: st.rec && st.rec.imported ? 1 : 0 });
            DS.complete({ action: 'sign', n: out.length });
        }).catch(function (err) {
            if (err && err.message === 'locked') DS.toast(t('need_unlock'), 'warning');
            else DS.fail(err, { stage: 'sign' }, t('err_sign'));
        }).then(function () {
            st.busy = false; setProgress('');
            els.root.classList.remove('ds-busy');
            renderKey();
        });
    }

    function setProgress(text) {
        DS.show(els.progress, !!text);
        els.progress.textContent = text || '';
    }

    function clearResults() {
        st.results = [];
        els.results.innerHTML = '';
        DS.show(els.results, false);
        els.root.classList.remove('ds-has-result');
        renderPreview();
    }

    function pemOf(der) {
        var b = DS.b64(der);
        return '-----BEGIN CMS-----\n' + b.replace(/(.{64})/g, '$1\n').replace(/\n$/, '') + '\n-----END CMS-----\n';
    }

    function renderResults(info) {
        var host = els.results;
        host.innerHTML = '';
        DS.show(els.previewWrap, false); DS.show(els.idle, false);
        var art = DS.el('article', 'ds-case ds-lvl-ok');
        var head = DS.el('div', 'ds-verdict ds-lvl-ok');
        var ico = DS.el('div', 'ds-verdict-ico'); ico.appendChild(DS.icon('seal-ok')); head.appendChild(ico);
        var box = DS.el('div', 'ds-verdict-txt');
        box.appendChild(DS.el('h3', 'ds-verdict-t', st.results.length > 1 ? DS.plural(st.results.length, 'signed_n') : t('signed_one')));
        box.appendChild(DS.el('p', 'ds-verdict-s', t('signed_sub', { name: (st.rec.identity && st.rec.identity.name) || '', fp: st.rec.fingerprint })));
        head.appendChild(box);
        art.appendChild(head);

        var list = DS.el('div', 'ds-outlist');
        st.results.forEach(function (r) {
            var row = DS.el('div', 'ds-docrow');
            var ic = DS.el('div', 'ds-docrow-ico ds-kind-seal'); ic.appendChild(DS.icon('seal')); row.appendChild(ic);
            var tx = DS.el('div', 'ds-docrow-txt');
            tx.appendChild(DS.dataEl('b', null, r.sigName));
            tx.appendChild(DS.el('span', null, DS.fmtSize(r.sig.length) + ' · ' + t(st.attached ? 'out_attached' : 'out_detached') + (r.timestamped ? ' · ' + t('out_ts') : '')));
            row.appendChild(tx);
            var act = DS.el('div', 'ds-docrow-act');
            var dl = DS.el('button', 'tc-btn sm', null); dl.type = 'button';
            dl.appendChild(DS.icon('download')); dl.appendChild(document.createTextNode(t('download')));
            dl.addEventListener('click', function () { saveSig(r, 'button'); });
            act.appendChild(dl);
            row.appendChild(act);
            list.appendChild(row);
            if (r.text) {
                var pem = DS.el('textarea', 'tc-in ds-pem'); pem.readOnly = true; pem.value = pemOf(r.sig); pem.rows = 4;
                pem.setAttribute('aria-label', t('pem_label'));
                list.appendChild(pem);
                var cp = DS.el('button', 'tc-btn sm ghost'); cp.type = 'button';
                cp.appendChild(DS.icon('copy')); cp.appendChild(document.createTextNode(t('pem_copy')));
                cp.addEventListener('click', function () { DS.copy(pem.value); DS.ae('copy_pem'); });
                list.appendChild(cp);
            }
        });
        art.appendChild(list);

        var acts = DS.el('div', 'ds-case-actions');
        if (st.results.length > 1) {
            var all = DS.el('button', 'tc-btn', null); all.type = 'button';
            all.appendChild(DS.icon('download')); all.appendChild(document.createTextNode(t('download_all_sigs')));
            all.addEventListener('click', function () { downloadAllSigs(false); });
            acts.appendChild(all);
        }
        var pack = DS.el('button', 'tc-btn ghost', null); pack.type = 'button';
        pack.appendChild(DS.icon('zip')); pack.appendChild(document.createTextNode(t('download_bundle')));
        pack.addEventListener('click', downloadBundle);
        acts.appendChild(pack);
        // Что увидит получатель — та же проверка во вкладке «Проверить», с этими
        // же файлами (для PDF там же — копия с отметкой об ЭП для печати).
        if (DS.openVerify) {
            var see = DS.el('button', 'tc-btn ghost', null); see.type = 'button';
            see.appendChild(DS.icon('eye')); see.appendChild(document.createTextNode(t('check_as_recipient')));
            see.addEventListener('click', function () {
                var files = [];
                st.results.forEach(function (r) {
                    if (!st.attached) files.push(r.file || new File([r.bytes], DS.safeName(r.name, 'text.txt'), { type: 'text/plain' }));
                    files.push(new File([r.sig], DS.safeName(r.sigName, 'document.sig'), { type: 'application/pkcs7-signature' }));
                });
                DS.ae('check_as_recipient', { n: st.results.length });
                DS.openVerify(files, 'from_sign');
            });
            acts.appendChild(see);
        }
        art.appendChild(acts);

        if (info.tsFailed) {
            // Отказ гейта несёт человеческую фразу в `error` (ToolsController::serverLaneRefusal),
            // вместе с числом Премиума — показываем её, а не общую строку.
            art.appendChild(DS.el('p', 'tc-msg warn', info.tsLimit ? (info.tsLimit.error || info.tsLimit.message || t('ts_limit')) : t('ts_failed')));
        }
        var how = DS.el('p', 'tc-note ds-how', t('how_recipient_checks'));
        art.appendChild(how);
        host.appendChild(art);
        DS.show(host, true);
        els.root.classList.add('ds-has-result');
        if (!st.rec.backedUp && !st.rec.imported) DS.show(els.backupNudge, true);
    }

    function readme() {
        var loc = root.__LOCALE || 'ru';
        var url = root.location.origin + '/' + loc + '/document-signer';
        return t('readme_body', { url: url, fp: st.rec ? st.rec.fingerprint : '', name: st.rec && st.rec.identity ? st.rec.identity.name : '' }).replace(/\\n/g, '\n');
    }

    // Одна выдача на кнопку «Скачать» и на автовыдачу — имя и байты не
    // разъезжаются (память feedback_no_sticky_no_auto_scroll: тул с кнопкой
    // «сделать» отдаёт файл сам, формат выбран ДО кнопки).
    function saveSig(r, via) {
        DS.save(new Blob([r.sig], { type: 'application/pkcs7-signature' }), DS.safeName(r.sigName, 'document.sig'));
        DS.ae('download_sig', { via: via });
    }
    // Подпись файлов — ответ на нажатие «Подписать», и он приходит сам: на
    // телефоне результат ниже сгиба, а прокручивать страницу за человека
    // нельзя. Текст — нет: там ответом служит подпись текстом (PEM) на экране.
    function autoDeliver() {
        if (st.src === 'text' || !st.results.length) return;
        if (st.results.length === 1) saveSig(st.results[0], 'auto');
        else downloadAllSigs(true);
    }

    function ensureBatch() {
        return root.__batchDeliver ? Promise.resolve(root.__batchDeliver) : root.__ensureBatchDeliver();
    }
    // auto: жеста уже нет (подпись шла асинхронно) — диалог папки не откроется,
    // поэтому сразу один архив; по кнопке — лестница примитива (папка → архив).
    function downloadAllSigs(auto) {
        var items = st.results.map(function (r) { return { name: DS.safeName(r.sigName, 'document.sig'), blob: new Blob([r.sig], { type: 'application/pkcs7-signature' }) }; });
        ensureBatch().then(function (BD) {
            return BD.deliver(items, { zipName: t('zip_sigs_name') + '.zip', slug: DS.SLUG, archiveOnly: auto === true });
        }).then(function (res) { DS.ae('download_all_sigs', { via: res && res.via, n: items.length, auto: auto === true ? 1 : 0 }); })
            .catch(function (e) { DS.fail(e, { stage: 'batch' }, t('err_bundle')); });
    }
    // Архив для отправки: документ + его подпись + README с тем, как проверить.
    // Имена записей делает уникальными __batchDeliver (два «Договор.pdf» из
    // разных папок больше не затирают друг друга).
    function downloadBundle() {
        var items = [];
        st.results.forEach(function (r) {
            if (r.file) items.push({ name: DS.safeName(r.name, 'document'), blob: r.file });
            else if (r.bytes && !st.attached) items.push({ name: DS.safeName(r.name, 'text.txt'), blob: new Blob([r.bytes], { type: 'text/plain;charset=utf-8' }) });
            items.push({ name: DS.safeName(r.sigName, 'document.sig'), blob: new Blob([r.sig], { type: 'application/pkcs7-signature' }) });
        });
        items.push({ name: t('readme_name') + '.txt', blob: new Blob([readme()], { type: 'text/plain;charset=utf-8' }) });
        var base = st.results.length === 1 ? DS.baseName(st.results[0].name) + ' — ' + t('zip_signed_suffix') : t('zip_bundle_name');
        ensureBatch().then(function (BD) {
            return BD.deliver(items, { zipName: DS.safeName(base, 'signed') + '.zip', slug: DS.SLUG, archiveOnly: true });
        }).then(function (res) { DS.ae('download_bundle', { via: res && res.via, n: st.results.length }); })
            .catch(function (e) { DS.fail(e, { stage: 'bundle' }, t('err_bundle')); });
    }

    /* ═══ резервная копия и импорт ═══════════════════════════════════ */

    function askPassword(title, confirm) {
        return new Promise(function (resolve) {
            var dlg = els.pwDialog;
            els.pwTitle.textContent = title;
            els.pw1.value = ''; els.pw2.value = '';
            DS.show(els.pw2Row, !!confirm);
            els.pwErr.textContent = '';
            var done = function (val) { cleanup(); try { dlg.close(); } catch (e) { /* noop */ } resolve(val); };
            var onOk = function (e) {
                e.preventDefault();
                var p1 = els.pw1.value;
                if (confirm && p1.length < 6) { els.pwErr.textContent = t('pw_short'); return; }
                if (confirm && p1 !== els.pw2.value) { els.pwErr.textContent = t('pw_mismatch'); return; }
                if (!p1) { els.pwErr.textContent = t('pw_empty'); return; }
                done(p1);
            };
            var onCancel = function () { done(null); };
            function cleanup() {
                els.pwForm.removeEventListener('submit', onOk);
                els.pwCancel.removeEventListener('click', onCancel);
                dlg.removeEventListener('cancel', onCancel);
            }
            els.pwForm.addEventListener('submit', onOk);
            els.pwCancel.addEventListener('click', onCancel);
            dlg.addEventListener('cancel', onCancel);
            if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
            setTimeout(function () { els.pw1.focus(); }, 30);
        });
    }

    function backup() {
        if (!st.rec || !st.privateKey) { DS.toast(t('need_unlock'), 'warning'); return; }
        askPassword(t('backup_pw_title'), true).then(function (pw) {
            if (!pw) return;
            return crypto.subtle.exportKey('pkcs8', st.privateKey).then(function (pk8) {
                return P.Pkcs12.write({
                    certificates: [st.rec.certDer], key: new Uint8Array(pk8), password: pw,
                    friendlyName: (st.rec.identity && st.rec.identity.name) || 'Timbrica', profile: 'modern'
                });
            }).then(function (p12) {
                var nm = DS.safeName((st.rec.identity && st.rec.identity.name) || t('signer_default_name'), 'key') + ' — ' + t('backup_file_suffix') + '.p12';
                DS.save(new Blob([p12], { type: 'application/x-pkcs12' }), nm);
                st.rec.backedUp = true;
                persist(); renderKey();
                DS.toast(t('backup_done'), 'success');
                DS.ae('key_backup');
            });
        }).catch(function (e) { DS.fail(e, { stage: 'backup' }, t('err_backup')); });
    }

    function importFile(file) {
        DS.readBytes(file).then(function (bytes) {
            var txt = '';
            try { txt = new TextDecoder().decode(bytes).trim(); } catch (e) { /* binary */ }
            if (txt[0] === '{') return importLegacyJson(JSON.parse(txt));
            var der = bytes;
            var u = P.Cms.unwrap(bytes); if (u) der = u.der;
            return askPassword(t('import_pw_title'), false).then(function (pw) {
                if (pw == null) return null;
                return P.Pkcs12.read(der, pw).then(function (res) {
                    var k = res.keys[0];
                    if (!k) throw new Error('p12_no_key');
                    var certDer = k.certificateIndex != null ? res.certificates[k.certificateIndex].der : (res.certificates[0] && res.certificates[0].der);
                    if (!certDer) throw new Error('p12_no_cert');
                    var extra = res.certificates.filter(function (c, n) { return n !== k.certificateIndex; }).map(function (c) { return c.der; });
                    return DS.importPkcs8(k.pkcs8).then(function (imp) {
                        var cert = P.X509.parse(certDer);
                        return DS.fingerprint(cert.spki).then(function (fp) {
                            var sp = cert.subject;
                            var self = cert.selfIssued;
                            st.rec = {
                                v: 3, alg: imp.kind === 'RSA' ? 'RSA' : 'ECDSA', created: Date.now(),
                                imported: !self, backedUp: true, privateKey: imp.key, publicKey: null, enc: null,
                                identity: { name: sp.get('CN') || [sp.get('SN'), sp.get('GN')].filter(Boolean).join(' '), email: sp.get('emailAddress') || '', org: sp.get('O') || '' },
                                certDer: certDer, spki: cert.spki, fingerprint: fp, extraCerts: extra
                            };
                            st.privateKey = imp.key; st.kind = imp.kind;
                            fillForm(st.rec.identity);
                            return persist().then(function () {
                                DS.toast(t('key_imported'), 'success');
                                DS.ae('key_import', { kind: imp.kind, self: self ? 1 : 0 });
                                renderKey();
                            });
                        });
                    });
                });
            });
        }).catch(function (e) {
            var wrong = e && (e.message === 'WRONG_PASSWORD' || e.macFailed);
            DS.toast(t(wrong ? 'err_pw_wrong' : 'err_key_import'), 'error');
            if (!wrong) DS.fail(e, { stage: 'import' });
        });
    }

    // Ключи прежней версии тула: JSON с JWK (открытый или зашифрованный паролем).
    function importLegacyJson(obj, fromStorage) {
        var pubJwk = obj.publicJwk, privP;
        if (obj.protected && obj.priv_enc) {
            privP = askPassword(t('unlock_title'), false).then(function (pw) {
                if (pw == null) return null;
                return DS.decryptBytes(obj.priv_enc, pw).then(function (pt) { return JSON.parse(new TextDecoder().decode(pt)); });
            });
        } else privP = Promise.resolve(obj.privateJwk || (obj.kty === 'EC' && obj.d ? obj : null));
        return privP.then(function (privJwk) {
            if (!privJwk) return null;
            if (!pubJwk) pubJwk = { kty: 'EC', crv: privJwk.crv, x: privJwk.x, y: privJwk.y, ext: true };
            return Promise.all([
                crypto.subtle.importKey('jwk', privJwk, { name: 'ECDSA', namedCurve: 'P-256' }, true, ['sign']),
                crypto.subtle.importKey('jwk', pubJwk, { name: 'ECDSA', namedCurve: 'P-256' }, true, ['verify'])
            ]).then(function (k) {
                var identity = identityFromForm();
                if (!identity.name) identity.name = obj.signer || t('signer_default_name');
                return newRecord({ privateKey: k[0], publicKey: k[1] }, identity).then(function (rec) {
                    rec.backedUp = !fromStorage;
                    st.rec = rec; st.privateKey = k[0]; st.kind = 'EC';
                    fillForm(identity);
                    return persist().then(function () {
                        if (fromStorage) DS.store.dropLegacy();
                        else DS.toast(t('key_imported'), 'success');
                        DS.ae('key_import', { legacy: 1 });
                        renderKey();
                    });
                });
            });
        });
    }

    function protect() {
        askPassword(t('protect_title'), true).then(function (pw) {
            if (!pw) return;
            return crypto.subtle.exportKey('pkcs8', st.privateKey).then(function (pk8) {
                return DS.encryptBytes(new Uint8Array(pk8), pw);
            }).then(function (enc) {
                st.rec.enc = enc; st.rec.privateKey = null;
                return persist();
            }).then(function () {
                renderKey(); DS.toast(t('protect_done'), 'success'); DS.ae('key_protect');
            });
        }).catch(function (e) { DS.fail(e, { stage: 'protect' }); });
    }
    function unprotect() {
        st.rec.enc = null; st.rec.privateKey = st.privateKey;
        persist().then(function () { renderKey(); DS.ae('key_unprotect'); });
    }
    function unlock() {
        var pw = els.unlockPw.value;
        if (!pw || !st.rec || !st.rec.enc) return;
        DS.decryptBytes(st.rec.enc, pw).then(function (pk8) { return DS.importPkcs8(pk8); }).then(function (imp) {
            st.privateKey = imp.key; st.kind = imp.kind;
            els.unlockPw.value = '';
            renderKey(); DS.toast(t('key_unlocked'), 'success'); DS.ae('key_unlock');
        }).catch(function () { DS.toast(t('err_pw_wrong'), 'error'); });
    }
    function forget() {
        if (!root.confirm(t('forget_confirm'))) return;
        st.rec = null; st.privateKey = null;
        DS.store.clear(); DS.store.dropLegacy();
        renderKey(); clearResults();
        DS.toast(t('key_forgotten'), 'info'); DS.ae('key_forget');
    }

    function fillForm(id) {
        if (!id) return;
        els.name.value = id.name || ''; els.email.value = id.email || ''; els.org.value = id.org || '';
    }

    function setSrc(src) {
        st.src = src;
        Array.prototype.forEach.call(els.srcBtns, function (b) {
            var on = b.getAttribute('data-src') === src;
            b.classList.toggle('on', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        DS.show(els.fileBox, src === 'file'); DS.show(els.textBox, src === 'text');
        clearResults(); refreshSignBtn();
    }
    function setAttached(v) {
        st.attached = v;
        Array.prototype.forEach.call(els.fmtBtns, function (b) {
            var on = (b.getAttribute('data-fmt') === 'attached') === v;
            b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        clearResults();
    }

    S.init = function () {
        var $ = DS.$;
        els = {
            root: $('dsSign'), zone: $('dsSIn'), files: $('dsSFiles'), filesWrap: $('dsSFilesWrap'),
            text: $('dsSText'), fileBox: $('dsSFileBox'), textBox: $('dsSTextBox'),
            srcBtns: document.querySelectorAll('[data-src]'), fmtBtns: document.querySelectorAll('[data-fmt]'),
            name: $('dsSName'), email: $('dsSEmail'), org: $('dsSOrg'),
            keyNone: $('dsKeyNone'), keyHave: $('dsKeyHave'), keyLocked: $('dsKeyLocked'), keyName: $('dsKeyName'), keyAvatar: $('dsKeyAvatar'),
            keyFp: $('dsKeyFp'), keySub: $('dsKeySub'), backupNudge: $('dsBackupNudge'), editIdentity: $('dsEditIdentity'),
            protectBtn: $('dsProtect'), unprotectBtn: $('dsUnprotect'), unlockPw: $('dsUnlockPw'),
            go: $('dsGo'), goLabel: $('dsGoLabel'), goHint: $('dsGoHint'), progress: $('dsSProgress'),
            ts: $('dsTs'), results: $('dsSResults'), preview: $('dsPreview'), previewWrap: $('dsPreviewWrap'), previewNote: $('dsPreviewNote'), idle: $('dsSIdle'),
            pwDialog: $('dsPw'), pwForm: $('dsPwForm'), pwTitle: $('dsPwTitle'), pw1: $('dsPw1'), pw2: $('dsPw2'), pw2Row: $('dsPw2Row'), pwErr: $('dsPwErr'), pwCancel: $('dsPwCancel'),
            importInput: $('dsImportInput'), remember: $('dsRemember')
        };
        if (!els.root) return;

        if (root.__bindUploaderFile && els.zone) {
            root.__bindUploaderFile(els.zone, function (f, detail) {
                addFiles(detail && detail.files ? detail.files : [f]);
                if (els.zone.__uploaderReset) els.zone.__uploaderReset();
            });
        }
        Array.prototype.forEach.call(els.srcBtns, function (b) { b.addEventListener('click', function () { setSrc(b.getAttribute('data-src')); }); });
        Array.prototype.forEach.call(els.fmtBtns, function (b) { b.addEventListener('click', function () { setAttached(b.getAttribute('data-fmt') === 'attached'); DS.ae('sign_format', { f: b.getAttribute('data-fmt') }); }); });
        els.text.addEventListener('input', function () { clearResults(); refreshSignBtn(); });
        els.go.addEventListener('click', sign);
        els.ts.addEventListener('change', function () { st.timestamp = els.ts.checked; DS.ae('sign_ts_toggle', { on: st.timestamp ? 1 : 0 }); });
        $('dsBackup').addEventListener('click', backup);
        $('dsBackup2').addEventListener('click', backup);
        $('dsImport').addEventListener('click', function () { els.importInput.click(); });
        $('dsImport2').addEventListener('click', function () { els.importInput.click(); });
        els.importInput.addEventListener('change', function () { var f = els.importInput.files[0]; els.importInput.value = ''; if (f) importFile(f); });
        $('dsForget').addEventListener('click', forget);
        els.protectBtn.addEventListener('click', protect);
        els.unprotectBtn.addEventListener('click', unprotect);
        $('dsUnlock').addEventListener('click', unlock);
        els.unlockPw.addEventListener('keydown', function (e) { if (e.key === 'Enter') unlock(); });
        els.editIdentity.addEventListener('click', function () {
            DS.show(els.keyNone, true);
            els.name.focus();
        });
        // Меню ключа — <details>: работает без JS и без Popover API; здесь только
        // то, чего <details> не умеет сам — закрыться после выбора, по щелчку
        // мимо и по Escape (фокус возвращается на кнопку меню).
        var menu = $('dsKeyMenu');
        if (menu) {
            menu.addEventListener('click', function (e) {
                if (e.target.closest && e.target.closest('.ds-menu-list button')) menu.open = false;
            });
            document.addEventListener('click', function (e) {
                if (menu.open && !menu.contains(e.target)) menu.open = false;
            });
            menu.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && menu.open) {
                    menu.open = false;
                    var sm = menu.querySelector('summary');
                    if (sm) sm.focus();
                }
            });
        }
        [els.name, els.email, els.org].forEach(function (inp) {
            inp.addEventListener('input', function () {
                if (st.rec && !st.rec.imported) DS.setData(els.keyName, els.name.value || t('signer_default_name'));
                refreshSignBtn();
            });
        });
        if (els.remember) els.remember.addEventListener('change', function () {
            st.remember = els.remember.checked;
            if (!st.remember) DS.store.clear(); else persist();
            DS.ae('key_remember', { on: st.remember ? 1 : 0 });
        });
        if (root.__toolSettings && root.__toolSettings.bind) {
            try { root.__toolSettings.bind(DS.SLUG, els.ts, 'timestamp', false); st.timestamp = els.ts.checked; } catch (e) { /* noop */ }
        }

        // Ключ с прошлого раза: IndexedDB, иначе — миграция из localStorage.
        DS.store.load().then(function (rec) {
            if (rec && rec.certDer) {
                st.rec = rec; st.privateKey = rec.privateKey || null;
                st.kind = rec.alg === 'RSA' ? 'RSA' : 'EC';
                fillForm(rec.identity);
                renderKey();
                return;
            }
            var legacy = DS.store.legacy();
            if (legacy && !legacy.protected) return importLegacyJson(legacy, true);
            renderKey();
        }).catch(function () { renderKey(); });
        renderFiles();
        setSrc('file');
    };
})(typeof window !== 'undefined' ? window : globalThis);
